const params = new URLSearchParams(window.location.search);
// const shopifyHandle = params?.get('shopify-handle');
const region = params?.get('region')?.toUpperCase();
// const forceUpdate = params?.get('force-update') === 'true';
const gidNo = params?.get('gid-no');

const getStorefrontApiConfig = () => {
    checkRequiredParams();
    switch (region) {
        case 'HK':
        case 'AU':
            return {
                storeName: process.env[`REACT_APP_SHOPIFY_STORE_NAME_${region}`],
                accessToken: process.env[`REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN_${region}`],
                gidNo,
                // shopifyHandle,
            };
        default:
            return {
                storeName: process.env.REACT_APP_SHOPIFY_STORE_NAME,
                accessToken: `${process.env.REACT_APP_SHOPIFY_STOREFRONT_ACCESS_TOKEN}`,
                gidNo,
                // shopifyHandle,
            };
    }
}

const getAdminApiConfig = () => {
    checkRequiredParams();
    // admin api use the same server at the moment

    // switch (region) {
    //     case 'HK':
    //     case 'AU':
    //         return {
    //             uri: `${process.env[`REACT_APP_SHOPIFY_ADMIN_API_PROXY_URI_${region}`]}`,
    //             userName: process.env[`SHOPIFY_ADMIN_API_USERNAME_${region}`],
    //             accessToken: process.env[`REACT_APP_SHOPIFY_ADMIN_API_PASSWORD_${region}`],
    //             region,
    //             gidNo
    //         }
    //     default:
    //         return {
    //             uri: `${process.env.REACT_APP_SHOPIFY_ADMIN_API_PROXY_URI}`,
    //             userName: process.env.REACT_APP_SHOPIFY_ADMIN_API_USERNAME,
    //             accessToken: process.env.REACT_APP_SHOPIFY_ADMIN_API_PASSWORD,
    //             region,
    //             gidNo
    //         }
    // }

    return {
        uri: `${process.env.REACT_APP_SHOPIFY_ADMIN_API_PROXY_URI}`,
        userName: process.env.REACT_APP_SHOPIFY_ADMIN_API_USERNAME,
        accessToken: process.env.REACT_APP_SHOPIFY_ADMIN_API_PASSWORD,
        region,
        gidNo
    }
}

const checkRequiredParams = () => {
    // if (!shopifyHandle ) {
    //     throw new Error('shopify-handle is required');
    // }
    if (!gidNo) {
        throw new Error('gid-no is required');
    }

}

export {
    getStorefrontApiConfig,
    getAdminApiConfig,
    checkRequiredParams,
    // forceUpdate,
}